import { render, staticRenderFns } from "./AgentPromotionDialog.vue?vue&type=template&id=48064c42&scoped=true"
import script from "./AgentPromotionDialog.vue?vue&type=script&lang=ts"
export * from "./AgentPromotionDialog.vue?vue&type=script&lang=ts"
import style0 from "./AgentPromotionDialog.vue?vue&type=style&index=0&id=48064c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48064c42",
  null
  
)

export default component.exports